<script>
export default {
    name: "TextEllipsis",
    functional: true,
    props: {
        multiline: {
            default: 1,
        },
        maxWidth: {
            default: '50vw',
        },
    },
}
</script>

<template functional>
    <v-tooltip
        v-bind="attrs"
        v-on="listeners"
        top
        :max-width="props.maxWidth"
        transition="fade-transition"
    >
        <template v-slot:activator="{on, attrs}">
            <div
                v-on="on"
                v-bind="attrs"
                :class="['truncate', data.staticClass]"
                :style="[{'-webkit-line-clamp': props.multiline}, data.staticStyle]"
            >
                <slot></slot>
            </div>
        </template>
        <slot></slot>
    </v-tooltip>
</template>

<style scoped>
.truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}
</style>
